module.exports = __webpack_public_path__ + "img/mobility.bdb3cb0e.png";